/* eslint react/no-danger: 0 */
import React, { useRef } from 'react';
//import content from '../../content';
import { isEs } from "../../libs/lang";

const content = isEs() ? require('../../contentES').default.housing.masthead : require('../../content').default.housing.masthead;

const SubMasthead = props => {

    const copy = content;
    const containerRef = useRef(null);

    const renderFacets = (facet, i) =>
        <div className="facet" key={`facet_${i}`}>
                <p className="headline" dangerouslySetInnerHTML={{__html: facet.title}}/>
                <p className="subhead">{facet.summary}</p>
        </div>

    return (
        <section className="housing__subMasthead" id="subMasthead" ref={containerRef}>
            <div className="container__copy">
               {copy.facets.map((x, i) => renderFacets(x, i))}
            </div>
        </section>
    );
};

export default SubMasthead;
